import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const Plot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 1.5),
}));

export const LineArea = styled(Box)({
  position: "relative",
});
